import { Switch } from "antd";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { projectsDataStore } from "Stores";
import { documentsTableStore } from "../Stores/DocumentsTableStore";

interface DeletedFilesSwitcherProps extends WithTranslation {
  onChange: (val: boolean) => void;
  checked: boolean;
}

export const DeletedFilesSwitcher = withTranslation(I18N_NS.PROJECT)(
  observer(({ onChange, checked, t }: DeletedFilesSwitcherProps) => {
    const isAdmin = projectsDataStore.isAdmin;
    // tslint:disable-next-line: max-line-length
    const canSeeDeletedFiles =
      documentsTableStore.currentFolder.folderActions && documentsTableStore.currentFolder.folderActions.showDeleted;
    if (canSeeDeletedFiles) {
      const label = isAdmin ? "Show all that are marked as deleted" : "Show mine that are marked as deleted";
      return (
        <>
          <Switch className="mr-5" onChange={onChange} checked={checked} />
          {t(label)}
        </>
      );
    } else {
      return null;
    }
  })
);
